import { getCookie } from "../../utils/getCookie";
import { EAuthActions } from "../constants/auth.constants";
import { IAction } from "../interfaces/action.interface";

export interface IAuthReducer {
    hasAccess: boolean; 
}

const initialState : IAuthReducer = {
    hasAccess: !!getCookie("has_access") || false,
};

const authReducer = (state:IAuthReducer=initialState, action:IAction) : IAuthReducer => {
    switch(action.type) {
        case EAuthActions.SET_HAS_ACCESS: {
            return { ...state, hasAccess: action.payload }
        }
        default: {
            return state; 
        }
    }
};

export { authReducer };